import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi, useStrapiParams } from '@/hooks';
import { sidebarItems } from './sidebar';
import { useParams } from 'react-router-dom';
import type { OfertaTrabajo, StrapiListRequest, StrapiResponse } from '@/interfaces/strapi';
import { ROUTES } from '@/constants';
import { getJobOfferDetail } from '@/services/strapi';
import { JobOfferDetail } from '@/components';

export const Oferta = (): ReactElement => {
	const { oferta: ofertaId } = useParams<{ oferta: string }>();
	const params = useStrapiParams({
		page: 1,
		pageSize: 1,
		sort: 'id:desc',
		additionalFilters: ofertaId ? { documentId: { $eq: ofertaId } } : {},
	});

	const { data, loading } = useStrapiApi<StrapiResponse<OfertaTrabajo>, StrapiListRequest>(getJobOfferDetail, {
		autoFetch: true,
		params,
	});

	const offer = data?.data;

	usePageBreadcrumb([
		{ label: 'Servicios' },
		{ label: 'Portal de Empleo', to: ROUTES.SERVICIOS_PORTAL_EMPLEO },
		{ label: offer?.titulo ?? '' },
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return <section>{loading ? <p>Cargando…</p> : offer && <JobOfferDetail item={offer} />}</section>;
};
